import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SMALL_MARGIN, MIDDLE_MARGIN, BIG_MARGIN, colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: SMALL_MARGIN,
      marginBottom: BIG_MARGIN,
      [theme.breakpoints.down('sm')]: {
        paddingTop: MIDDLE_MARGIN,
      },
    },
    icon: {
      width: 80,
      height: 80,
    },
    title: {
      fontSize: 20,
      lineHeight: 1.4,
      fontWeight: 700,
      marginTop: MIDDLE_MARGIN,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
      },
    },
    description: {
      fontSize: 18,
      lineHeight: 1.5,
      textAlign: 'center',
      marginTop: SMALL_MARGIN,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
    controls: {
      marginTop: MIDDLE_MARGIN,
      display: 'flex',
      flexDirection: 'column',
    },
    link: {
      display: 'block',
      color: colorsPalette.white,
      fontWeight: 700,
      fontSize: 16,
      lineHeight: 1.2,
      textTransform: 'uppercase',
      margin: `${MIDDLE_MARGIN}px auto 0`,
    },
  }),
);

export default useStyles;
